module.exports = __webpack_public_path__ + "static/media/animal-07.cfe460bb.mp3";